import React from "react";
import PropTypes from "prop-types";
import { buildScopeTranslate } from "lib/I18n";
import { scoringWaitCopy } from "../resultUtils";
import { refPropType } from "../utils";

const tAwaiting = buildScopeTranslate("views.content.assessment_framework.assessments.pages.awaiting");

const AwaitingEvaluationScreen = ({
  showLongWaitMessage = false,
  headingRef = null,
}) => {
  const scoringWait = showLongWaitMessage ? scoringWaitCopy() : null;
  const title = scoringWait ? scoringWait.heading : tAwaiting("title");

  return (
    <div
      className="slds-align_absolute-center slds-grid slds-grid_vertical slds-grid_align-center slds-p-around_xx-large th-agentforce-assessment__loading"
      role="status"
      aria-live="polite"
      data-testid="awaiting-evaluation-screen">
      <h1
        ref={headingRef}
        className="slds-text-heading_medium"
        tabIndex="-1"
        data-testid="awaiting-evaluation-title">
        {title}
      </h1>
      <tds-spinner size="medium" data-testid="awaiting-evaluation-spinner" aria-hidden="true"></tds-spinner>
      {showLongWaitMessage ? (
        <div
          className="slds-m-top_medium slds-text-align_center th-agentforce-assessment__result-text"
          data-testid="awaiting-evaluation-subtitle">
          <p className="th-agentforce-assessment__result-secondary">{scoringWait.body}</p>
          <strong className="th-agentforce-assessment__result-secondary">{scoringWait.warning}</strong>
        </div>
      ) : null}
    </div>
  );
};

AwaitingEvaluationScreen.propTypes = {
  showLongWaitMessage: PropTypes.bool,
  headingRef: refPropType,
};

export default AwaitingEvaluationScreen;
